import PropTypes from 'prop-types';
import React from 'react';

import { UppyFeatureFlagWrapper } from '@components/common/uppy/UppyFeatureFlagWrapper';
import {
  formattedUppyAttachments,
  uniqueFilesByKey,
  duplicateSweetAlertOptions,
  getUniqueKey,
  sanitizeUppyKey,
} from '@helpers/uppy';

const GUEST_UPLOAD_FILE_SIZE_LIMIT = 1024 * 1024 * 1024 * 10; // 10GB

const isDefaultUploaderEnabled = BFG.hasFeature('uppy_uploader_features');
  const isUcsUploaderEnabled = BFG.hasFeature('uppy_with_companion_features');

const renderOldUploader = isDefaultUploaderEnabled || !isUcsUploaderEnabled

class GuestUploadUppy extends React.Component {
  triggerUpload = (files) => {
    const { appendFiles } = this.props;
    const uniqueKey = getUniqueKey();
    const uniqFiles = uniqueFilesByKey(files, uniqueKey);
    if (files.length !== uniqFiles.length) {
      window.swal(duplicateSweetAlertOptions, (removeDuplicates) => {
        if (removeDuplicates) {
          appendFiles(formattedUppyAttachments(uniqFiles));
        } else {
          appendFiles(formattedUppyAttachments(files));
        }
      });
    } else {
      appendFiles(formattedUppyAttachments(files));
    }
  }

  trigger() {
    return `uppy-guest-upload-trigger-${sanitizeUppyKey(this.props.uploadLinkKey)}`;
  }

  renderArea() {
    return (
      <div className={`uppy-guest-upload-area ${renderOldUploader ? '' : 'CompanionUploader'}`} id={this.trigger()}>
        <p>Click to add an asset</p>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderArea()}
        <UppyFeatureFlagWrapper
          {...this.props}
          guestUpload
          restrictions={{
            maxFileSize: GUEST_UPLOAD_FILE_SIZE_LIMIT, // 10GB
          }}
          button
          handleUpload={this.triggerUpload}
          template="file_ingest"
          trigger={`#${this.trigger()}`}
          uniqIdentifier={`guest-upload-uppy-${sanitizeUppyKey(this.props.uploadLinkKey)}`}
        />
      </React.Fragment>
    );
  }
}

GuestUploadUppy.propTypes = {
  uploadLinkKey: PropTypes.string.isRequired,
  appendFiles: PropTypes.func.isRequired
};

export default GuestUploadUppy;
